import { render, staticRenderFns } from "./SortByFilters.vue?vue&type=template&id=334b160a&scoped=true"
import script from "./SortByFilters.vue?vue&type=script&lang=js"
export * from "./SortByFilters.vue?vue&type=script&lang=js"
import style0 from "./SortByFilters.vue?vue&type=style&index=0&id=334b160a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334b160a",
  null
  
)

export default component.exports